import { defaultPageSize } from 'consts'
import { AnyAction } from 'redux'

export interface SettingsStateProps {
  pageSize: number
  pageSizeUsers: number
  pageSizeSites: number
  pageSizeCostCenters: number
  pageSizeSuperadmins?: number
}

const defaultSettings: SettingsStateProps = {
  pageSize: defaultPageSize,
  pageSizeUsers: defaultPageSize,
  pageSizeSites: defaultPageSize,
  pageSizeCostCenters: defaultPageSize,
}

const settings = (state = defaultSettings, action: AnyAction) => {
  switch (action.type) {
    case 'SET_SETTINGS':
      const { type, ...settingsOnly } = action
      const newState = settingsOnly

      return {
        ...state,
        ...newState,
      }

    default:
      return state
  }
}

export default settings
